
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z","fill":"#ECEBF0"}}),_c('path',{attrs:{"d":"M12.1192 7.00199C10.5074 6.94587 9.14874 8.08096 9.00358 9.59828C8.96075 10.0456 9.30724 10.4411 9.7772 10.4819C10.2394 10.5168 10.6621 10.1934 10.7054 9.74546C10.7677 9.09215 11.3517 8.59238 12.0497 8.62732C12.7121 8.65273 13.2805 9.20757 13.291 9.83864C13.2988 10.2807 13.0669 10.682 12.6704 10.9134C11.7132 11.4703 11.1415 12.1608 11.1415 13.1868C11.1415 13.6358 11.5241 14 11.9957 14C12.4674 14 12.85 13.6358 12.85 13.1868C12.85 12.732 13.1159 12.5599 13.5619 12.3004C14.4662 11.7737 15.0174 10.8197 14.9996 9.81164C14.974 8.3229 13.682 7.06288 12.1192 7.00199Z","fill":"#10001F"}}),_c('path',{attrs:{"d":"M12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z","fill":"#10001F"}})])
          )
        }
      }
    